import React, { useState, useEffect } from 'react';

const NAV_LINKS = ['About', 'Skills', 'Experience', 'Contact'];

function getInitialTheme() {
  try {
    return localStorage.getItem('theme') || 'dark';
  } catch {
    return 'dark';
  }
}

export default function Navbar() {
  const [scrolled,    setScrolled]   = useState(false);
  const [menuOpen,    setMenuOpen]   = useState(false);
  const [activeSection, setActive]   = useState('');
  const [theme, setTheme]            = useState(getInitialTheme);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    try { localStorage.setItem('theme', theme); } catch {}
  }, [theme]);

  const toggleTheme = () => setTheme(t => t === 'dark' ? 'light' : 'dark');

  // Scroll shadow
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Active section tracking via IntersectionObserver
  useEffect(() => {
    const sections = NAV_LINKS.map(l => document.getElementById(l.toLowerCase())).filter(Boolean);

    const observer = new IntersectionObserver(
      entries => {
        // Pick the entry with the largest intersection ratio that is intersecting
        const visible = entries
          .filter(e => e.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio);
        if (visible.length > 0) {
          setActive(visible[0].target.id);
        }
      },
      {
        rootMargin: '-20% 0px -60% 0px',
        threshold: [0, 0.25, 0.5, 0.75, 1],
      }
    );

    sections.forEach(s => observer.observe(s));
    return () => observer.disconnect();
  }, []);

  const close = () => setMenuOpen(false);

  return (
    <>
      <div
        className={`nav-overlay${menuOpen ? ' open' : ''}`}
        onClick={close}
        aria-hidden="true"
      />

      <nav className={`navbar${scrolled ? ' scrolled' : ''}`} role="navigation">
        <a href="#home" className="navbar__logo" onClick={close}>
          DP
        </a>

        <button
          className={`navbar__hamburger${menuOpen ? ' open' : ''}`}
          onClick={() => setMenuOpen(prev => !prev)}
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={menuOpen}
        >
          <span aria-hidden="true" />
          <span aria-hidden="true" />
          <span aria-hidden="true" />
        </button>

        <ul className={`navbar__links${menuOpen ? ' open' : ''}`}>
          {NAV_LINKS.map(link => (
            <li key={link}>
              <a
                href={`#${link.toLowerCase()}`}
                onClick={close}
                className={activeSection === link.toLowerCase() ? 'nav-active' : ''}
                aria-current={activeSection === link.toLowerCase() ? 'true' : undefined}
              >
                {link}
              </a>
            </li>
          ))}
          <li>
            <a
              href="/others/resume_dhruvinpatel.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="navbar__resume"
              onClick={close}
            >
              Resume
            </a>
          </li>
          <li>
            <button
              className="navbar__theme-toggle"
              onClick={toggleTheme}
              aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
            >
              <i className={`fa ${theme === 'dark' ? 'fa-sun-o' : 'fa-moon-o'}`} aria-hidden="true" />
            </button>
          </li>
        </ul>
      </nav>
    </>
  );
}
